import { X, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const PAINS = [
  "A ansiedade de um mundo que nunca desliga",
  "A raiva diante do que você não controla",
  "A comparação constante nas redes sociais",
  "O medo do futuro e a prisão do passado",
];

const ANSWERS = [
  "A dicotomia do controle: foque só no que depende de você",
  "Premeditatio malorum: prepare a mente antes da tempestade",
  "Amor fati: transforme obstáculos em matéria-prima",
  "O diário estoico: clareza em 10 minutos por dia",
];

export const ProblemSolution = () => (
  <section data-testid="problem-solution-section" className="py-20 md:py-28 relative">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#d4af37]">O dilema moderno</p>
        <h2 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#f4f1ea] leading-snug">
          O século XXI cobra caro da sua mente.
          <span className="text-gold-gradient italic"> A resposta tem 2.300 anos.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Reveal delay={0.1}>
          <div className="h-full rounded-2xl border border-white/[0.06] bg-[#14141a] p-8 md:p-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">O ruído</p>
            <h3 className="mt-3 font-serif text-xl sm:text-2xl font-semibold text-zinc-300">O mundo moderno</h3>
            <ul className="mt-8 space-y-5">
              {PAINS.map((pain, i) => (
                <li key={pain} className="flex items-start gap-4">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-red-950/60 border border-red-900/50 flex items-center justify-center shrink-0">
                    <X className="w-3.5 h-3.5 text-red-400/80" />
                  </span>
                  <span className="text-sm sm:text-base text-zinc-400 leading-relaxed">{pain}</span>
                  <span className="sr-only">{i}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.22}>
          <div className="h-full rounded-2xl border border-[#d4af37]/25 bg-gradient-to-b from-[#1f1a08]/60 to-[#14141a] p-8 md:p-10 gold-glow">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">A clareza</p>
            <h3 className="mt-3 font-serif text-xl sm:text-2xl font-semibold text-gold-gradient">A sabedoria estoica</h3>
            <ul className="mt-8 space-y-5">
              {ANSWERS.map((answer) => (
                <li key={answer} className="flex items-start gap-4">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[#d4af37]/15 border border-[#d4af37]/40 flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-[#f5d77f]" />
                  </span>
                  <span className="text-sm sm:text-base text-zinc-300 leading-relaxed">{answer}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
